module.exports = __webpack_public_path__ + "static/media/IMG_6428.2e78fe9c.JPG";